import NamedDto from 'modules/base/dto/NamedDto';
import DriverType from './DriverType';

export default class DriverDto extends NamedDto {
	constructor() {
		super();
		/** @type {DriverType} */
		this.type = null;
	}

	/**
	 * @typedef {Object} _DriverDtoProps
	 * @property {DriverType} type
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _DriverDtoProps} DriverDtoProps
	 */
	/**
	 *
	 * @param {DriverDtoProps} props
	 * @returns {DriverDto}
	 */
	setup(props) {
		super.setup(props);
		this.type = props.type;
		return this;
	}
}
